<template>
  <div>
    <!-- //! Have to add snackbar -->
    <v-card flat class="grey lighten-5">
      <v-layout class="ml-3" row wrap>
        <v-flex class="mt-1" xs12 sm12 md4>
          <div class="pa-2">
            <v-card class="mx-auto">
              <v-card dark>
                <v-img
                  v-if="film.thumburls"
                  :src="film.thumburls"
                  gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
                  max-height="270px"
                  contain
                >
                </v-img>
                <v-container
                  v-else
                  bg
                  fill-height
                  grid-list-md
                  text-xs-center
                  class="media_file_container"
                >
                  <v-layout row wrap align-center>
                    <v-flex>
                      <v-icon size="100"
                        >$vuetify.icons.rms_image_not_found</v-icon
                      >
                      <div class="title grey--text">
                        {{ $t("screener.film.thumbnails.not_available") }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
              <v-card-text class="py-0">
                <v-timeline dense align-top>
                  <v-timeline-item
                    :color="uploaded_media_count ? 'success' : 'error'"
                    small
                  >
                    <v-layout row wrap pt-2>
                      <v-flex xs10 md10>
                        <v-layout row wrap>
                          <v-flex xs12 md12>
                            <strong
                              :class="
                                uploaded_media_count
                                  ? 'success--text'
                                  : 'error--text'
                              "
                            >
                              {{
                                $t(
                                  "film.update.tabs.overview.timeline.media_uploaded"
                                )
                              }}
                            </strong>
                          </v-flex>
                          <v-flex xs12 md12>
                            <span v-if="uploaded_media_count">{{
                              $t(
                                "film.update.tabs.overview.timeline.media_uploaded.subtitle",
                                {
                                  media_count: uploaded_media_count,
                                }
                              )
                            }}</span>
                            <span v-else class="error--text">{{
                              $t(
                                "film.update.tabs.overview.timeline.media_uploaded.error"
                              )
                            }}</span>
                          </v-flex>
                          <v-flex xs12 md12>
                            <v-tooltip top color="greyDarken1">
                              <template v-slot:activator="{ on }">
                                 <v-btn v-on="on" flat outline icon small class="pa-0 ma-0" color="success" @click="$emit('navigateToUpload')">
                                  <v-icon small>$vuetify.icons.rms_upload</v-icon>
                                </v-btn>
                              </template>
                              <span class="white--text body-1">{{
                                $t("screener.film.import.steps.upload_file.title")
                              }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-timeline-item>
                  <v-timeline-item
                    :color="film.screeners.length ? 'success' : 'error'"
                    small
                  >
                    <v-layout row wrap pt-2>
                      <v-flex xs10 md10>
                        <v-layout row wrap>
                          <v-flex xs12 md12>
                            <strong
                              :class="
                                film.screeners.length
                                  ? 'success--text'
                                  : 'error--text'
                              "
                            >
                              {{
                                $t(
                                  "film.update.tabs.overview.timeline.media_attached"
                                )
                              }}
                            </strong>
                          </v-flex>
                          <v-flex xs12 md12>
                            <span v-if="film.screeners.length">{{
                              $t(
                                "film.update.tabs.overview.timeline.media_attached.attached"
                              )
                            }}</span>
                            <span v-else class="error--text">{{
                              $t(
                                "film.update.tabs.overview.timeline.media_attached.not_attached"
                              )
                            }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-timeline-item>
                  <v-timeline-item
                    :color="
                      movie &&
                      movie.encoding_status == DEFINES.ENCODING_STATUS.ENCODED
                        ? 'success'
                        : 'error'
                    "
                    small
                  >
                    <v-layout row wrap pt-2>
                      <v-flex xs10 md10>
                        <v-layout row wrap>
                          <v-flex xs12 md12>
                            <strong
                              :class="
                                movie &&
                                movie.encoding_status ==
                                  DEFINES.ENCODING_STATUS.ENCODED
                                  ? 'success--text'
                                  : 'error--text'
                              "
                            >
                              {{
                                $t(
                                  "film.update.tabs.overview.timeline.encoding_status"
                                )
                              }}
                            </strong>
                          </v-flex>
                          <v-flex xs12 md12>
                            <span v-if="movie && movie.encoding_status">{{
                              $t(
                                "film.update.tabs.overview.timeline.encoding_status"
                              )
                            }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-timeline-item>
                  <v-timeline-item :color="enablePreview ?'success' :'error'" small>
                    <v-layout row wrap pt-2>
                      <v-flex xs10 md10>
                        <v-layout row wrap>
                          <v-flex xs12 md12>
                            <strong  :class="enablePreview ?'success--text' :'error--text'">
                              {{
                                $t("film.update.tabs.overview.timeline.preview")
                              }}
                            </strong>
                          </v-flex>
                          <v-flex xs12 md12>
                            <span v-if="enablePreview" class="success--text">
                              {{
                                $t("film.update.tabs.overview.timeline.preview.success")
                              }}
                              <v-btn color="primary" dark small @click.stop="watchPreview">{{$t("screener.btn.preview")}}</v-btn>
                            </span>
                            <span v-else class="error--text">{{
                              $t(
                                "film.update.tabs.overview.timeline.preview.error"
                              )
                            }}
                          </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
        <v-flex xs12 sm12 md8>
          <v-flex xs12 md12 sm12>
            <v-layout>
              <v-flex mx-1>
                <v-card flat color="transparent">
                  <v-card-title
                    class="body-2 grey--text text--lighten-1 font-weight-bold"
                    >{{
                      $t("film.update.tabs.overview.basic_details")
                    }}</v-card-title
                  >
                  <div>
                    <v-layout>
                      <v-flex xs12 sm12 md12 px-3 mt-2>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md4>
                            <v-card class="pa-4 ma-2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{ on }">
                                      <div
                                        v-if="film.screeners && film.screeners.length"
                                        v-on="on"
                                        class="headline text-xs-center success--text"
                                      >
                                        Yes
                                      </div>
                                      <div
                                        v-else
                                        v-on="on"
                                        class="headline text-xs-center error--text"
                                      >
                                        No
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t("film.update.tabs.overview.media.attached.tooltip")
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                      body-2
                                      grey--text
                                      text--darken-1 text-xs-center
                                    "
                                  >
                                    {{
                                      $t(
                                        "film.update.tabs.overview.basic_details.media_attached"
                                      )
                                    }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex mx-1>
                <v-card flat color="transparent">
                  <v-card-title
                    class="body-2 grey--text text--lighten-1 font-weight-bold"
                    >{{
                      $t("film.update.tabs.overview.media_and_streaming")
                    }}</v-card-title
                  >
                  <div>
                    <v-layout>
                      <v-flex xs12 sm12 md12 px-3 mt-2>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md4>
                            <v-card class="pa-4 ma-2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{ on }">
                                      <div
                                        v-if="movie && movie.encoding_status"
                                        v-on="on"
                                        :class="['headline', 'text-xs-center', 'success--text']"
                                      >
                                        <template v-if="movie.encoding_status ==  DEFINES.ENCODING_STATUS.ENCODED && ((!movie.streams_copied_to_fs) || (!movie.keys_copied_to_fs))">
                                          <span class="grey--text">{{DEFINES.ENCODING_STATUS.ENCODING}}</span>
                                        </template>
                                        <template v-else>
                                          {{movie.encoding_status}}
                                        </template>
                                      </div>
                                       <div
                                        v-else
                                        v-on="on"
                                        :class="['headline', 'text-xs-center', 'error--text']"
                                      >
                                        NA
                                      </div>

                                    </template>
                                    <span class="white--text body-1">{{
                                      $t("film.update.tabs.overview.media.encoding.status.tooltip")
                                    }}</span>
                                  </v-tooltip>
                                  <div

                                    class="
                                      body-2
                                      grey--text
                                      text--darken-1 text-xs-center
                                    "
                                  >
                                    {{
                                      $t(
                                        "film.update.tabs.overview.media_and_streaming.encoding_status"
                                      )
                                    }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm12 md4>
                            <v-card class="pa-4 ma-2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{ on }">
                                      <div
                                        v-if="film.is_external_src"
                                        v-on="on"
                                        class="body-2 text-xs-center error--text"
                                      >
                                        {{$t('film.update.screener.streaming.external')}}
                                      </div>
                                      <div
                                        v-else
                                        v-on="on"
                                        class="body-2 text-xs-center success--text"
                                      >
                                        {{$t('screener.streaming.internal')}}
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t("film.update.tabs.overview.streaming.source.tooltip")
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                      body-2
                                      grey--text
                                      text--darken-1 text-xs-center
                                    "
                                  >
                                    {{
                                      $t(
                                        "film.update.tabs.overview.media_and_streaming.streaming_source"
                                      )
                                    }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm12 md4>
                            <v-card class="pa-4 ma-2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{ on }">
                                      <div
                                        v-on="on"
                                        class="headline text-xs-center"
                                      >
                                        {{uploaded_media_count}}
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t("film.update.tabs.overview.media.count.tooltip")
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                      body-2
                                      grey--text
                                      text--darken-1 text-xs-center
                                    "
                                  >
                                    {{
                                      $t(
                                        "film.update.tabs.overview.media_and_streaming.uploaded_media"
                                      )
                                    }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex mx-1>
                <v-card flat color="transparent">
                  <v-card-title
                    class="body-2 grey--text text--lighten-1 font-weight-bold"
                    >{{
                      $t("film.update.tabs.overview.right_holder")
                    }}</v-card-title
                  >
                  <div>
                    <v-layout>
                      <v-flex xs12 sm12 md12 px-3 mt-2>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md8>
                            <v-card class=" ma-2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{ on }">
                                      <div
                                        v-on="on"
                                        class="headline text-xs-center"
                                      >
                                       <UploadingLink :film="film" :company="company" :rememberSection="false"/>
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t("film.update.tabs.overview.right_holder.generate.upload_link")
                                    }}</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm12 md4>
                            <v-card class="pa-4 ma-2">
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{ on }">
                                      <div
                                        v-if="film.right_holder_share"
                                        v-on="on"
                                        class="headline text-xs-center success--text"
                                      >
                                        {{film.right_holder_share+'%'}}
                                      </div>
                                      <div
                                        v-else
                                        v-on="on"
                                        class="headline text-xs-center success--text"
                                      >
                                        NA
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t("film.update.tabs.overview.right_holder.share.tooltip")
                                    }}</span>
                                  </v-tooltip>
                                  <div
                                    class="
                                      body-2
                                      grey--text
                                      text--darken-1 text-xs-center
                                    "
                                  >
                                    {{
                                      $t(
                                        "film.update.tabs.overview.right_holder.revenue_sharing"
                                      )
                                    }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex mx-1>
                <v-card flat color="transparent">
                  <v-card-title
                    class="body-2 grey--text text--lighten-1 font-weight-bold"
                    >{{
                      $t("screener.avails.analytics.heading")
                    }}</v-card-title
                  >
                  <div>
                    <v-layout>
                      <v-flex xs12 sm12 md12 px-3>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-card class="ma-2">
                              <v-flex xs12 sm12 md12 px-3>
                                <div class="subheadline pt-2 pb-2 grey--text text--lighten-1 font-weight-bold">
                                  <span>{{
                                      $t('screener.avails.film.analytics.subheading')
                                    }}
                                  </span>
                                </div>
                                <v-card>
                                  <div class="subheadline pt-3 pl-3 grey--text text--lighten-1 font-weight-bold">
                                    <span>{{
                                        $t('screener.avails.film.analytics.subheading.users')
                                      }}
                                    </span>
                                  </div>
                                  <v-layout row wrap>
                                    <v-flex
                                      xs12
                                      sm12
                                      md4
                                      pa-2
                                    >
                                      <v-card flat class="pa-3">
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-tooltip top color="greyDarken1">
                                              <template v-slot:activator="{on}">
                                                <div
                                                  v-on="on"
                                                  class="headline text-xs-center"
                                                >
                                                  {{
                                                    analytics?analytics.hour.users:0
                                                  }}
                                                </div>
                                              </template>
                                              <span class="white--text body-1">{{
                                                $t('screener.overview.analytics.hour.tooltip')
                                              }}</span>
                                            </v-tooltip>
                                            <div
                                              class="
                                            subheading
                                            saSecondary--text
                                            text-xs-center
                                          "
                                            >
                                              {{ $t('screener.overview.analytics.hour') }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      sm12
                                      md4
                                      pa-2
                                    >
                                      <v-card flat class="pa-3">
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-tooltip top color="greyDarken1">
                                              <template v-slot:activator="{on}">
                                                <div
                                                  v-on="on"
                                                  class="headline text-xs-center"
                                                >
                                                  {{
                                                    analytics?analytics.today.users:0
                                                  }}
                                                </div>
                                              </template>
                                              <span class="white--text body-1">{{
                                                $t('screener.overview.analytics.today.tooltip')
                                              }}</span>
                                            </v-tooltip>
                                            <div
                                              class="
                                            subheading
                                            saSecondary--text
                                            text-xs-center
                                          "
                                            >
                                              {{ $t('screener.overview.analytics.today') }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      sm12
                                      md4
                                      pa-2
                                    >
                                      <v-card flat class="pa-3">
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-tooltip top color="greyDarken1">
                                              <template v-slot:activator="{on}">
                                                <div
                                                  v-on="on"
                                                  class="headline text-xs-center"
                                                >
                                                  {{
                                                    analytics?analytics.total.users:0
                                                  }}
                                                </div>
                                              </template>
                                              <span class="white--text body-1">{{
                                                $t('screener.overview.analytics.total.tooltip')
                                              }}</span>
                                            </v-tooltip>
                                            <div
                                              class="
                                            subheading
                                            saSecondary--text
                                            text-xs-center
                                          "
                                            >
                                              {{ $t('screener.overview.analytics.total') }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                  <div class="subheadline pt-3 pl-3 grey--text text--lighten-1 font-weight-bold">
                                    <span>{{
                                        $t('screener.avails.film.analytics.subheading.watch_time')
                                      }}
                                    </span>
                                  </div>
                                  <v-layout row wrap>
                                    <v-flex
                                      xs12
                                      sm12
                                      md4
                                      pa-2
                                    >
                                      <v-card flat class="pa-3">
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-tooltip top color="greyDarken1">
                                              <template v-slot:activator="{on}">
                                                <div
                                                  v-on="on"
                                                  class="headline text-xs-center"
                                                >
                                                  {{
                                                    analytics?((analytics.hour.time/60).toFixed(3)):0
                                                  }}
                                                </div>
                                              </template>
                                              <span class="white--text body-1">{{
                                                $t('screener.overview.analytics.hour_watch_time.tooltip')
                                              }}</span>
                                            </v-tooltip>
                                            <div
                                              class="
                                            subheading
                                            saSecondary--text
                                            text-xs-center
                                          "
                                            >
                                              {{ $t('screener.overview.analytics.hour') }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      sm12
                                      md4
                                      pa-2
                                    >
                                      <v-card flat class="pa-3">
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-tooltip top color="greyDarken1">
                                              <template v-slot:activator="{on}">
                                                <div
                                                  v-on="on"
                                                  class="headline text-xs-center"
                                                >
                                                  {{
                                                     analytics?((analytics.today.time/60).toFixed(3)):0
                                                  }}
                                                </div>
                                              </template>
                                              <span class="white--text body-1">{{
                                                $t('screener.overview.analytics.today_watch_time.tooltip')
                                              }}</span>
                                            </v-tooltip>
                                            <div
                                              class="
                                            subheading
                                            saSecondary--text
                                            text-xs-center
                                          "
                                            >
                                              {{ $t('screener.overview.analytics.today') }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      sm12
                                      md4
                                      pa-2
                                    >
                                      <v-card flat class="pa-3">
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-tooltip top color="greyDarken1">
                                              <template v-slot:activator="{on}">
                                                <div
                                                  v-on="on"
                                                  class="headline text-xs-center"
                                                >
                                                  {{
                                                     analytics?((analytics.total.time/60).toFixed(3)):0
                                                  }}
                                                </div>
                                              </template>
                                              <span class="white--text body-1">{{
                                                $t('screener.overview.analytics.total_watch_time.tooltip')
                                              }}</span>
                                            </v-tooltip>
                                            <div
                                              class="
                                            subheading
                                            saSecondary--text
                                            text-xs-center
                                          "
                                            >
                                              {{ $t('screener.overview.analytics.total') }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-tooltip top color="greyDarken1">
                                    <template v-slot:activator="{ on }">
                                      <div
                                        v-on="on"
                                        class="headline text-xs-center text-md-center pa-2"
                                      >
                                        <v-btn
                                          color="primary"
                                          dark
                                          @click="
                                            $router.push({
                                              name: 'analytics.index',
                                              params: {
                                                selectedFilm: film,
                                                selectedTab: 'film_wise',
                                              },
                                            })
                                          "
                                          >{{ $t('screener.avails.film.analytics') }}</v-btn
                                        >
                                      </div>
                                    </template>
                                    <span class="white--text body-1">{{
                                      $t("screener.avails.film.analytics.tooltip")
                                    }}</span>
                                  </v-tooltip>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Preview Player -->
    <v-container class="pa-0" v-if="showPreview">
      <v-dialog max-width="55vmin" v-model="showPreview" persistent>
        <v-card>
          <v-card-title>
            <div class="title">{{ $t("screener.preview.title") }}</div>
            <v-spacer></v-spacer>
            <v-btn
              small
              dark
              icon
              color="grey"
              @click="closePreview"
              class="mx-0"
            >
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <ScreenerPlayer
              :movie="previewUrl"
              :subtitles="subtitles"
            ></ScreenerPlayer>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState,mapGetters } from "vuex";
import UploadingLink from "@/components/UploadingLink";
import ScreenerPlayer from "@/components/screener/Player";
export default {
  name: "FilmOverview",
  props: {
    film: {
      type: Object,
      default: null,
    },
    uploaded_media_count: {
      type: String|Number,
      default: null,
    }
  },
  data() {
    return {
      showPreview: false,
      previewUrl: null,
      analytics:null
    }
  },
  components: {
    UploadingLink,
    ScreenerPlayer
  },
  mounted(){
      this.fetchAnalyticsOverview();
  },
  computed: {
    movie: function () {
      return this.$store.getters["film/getMediasFromId"](
        this.DEFINES.MEDIA.FILM.SCREENERS
      )[0];
    },
    ...mapState({
          company: state => state.company.company,
    }),
    subtitles: function() {
      return this.$store.getters["files/getSubtitles"]();
    },
    enablePreview: function () {
      if (this.film.is_external_src) return this.film.external_url !== null;
      else
        return this.movie
          ? this.movie.encoding_status == this.DEFINES.ENCODING_STATUS.ENCODED
          : false;
    },
    ...mapGetters('company', {
      timezone: 'getSelectedCompanyTimezone',
    }),
  },
  methods: {
    async fetchAnalyticsOverview() {
      try {
        var result = await this.$store.dispatch(
          'analytics/fetchEntityOverviewData',
          {
            entity_id: this.film.id,
            entity_type: 'video',
            timezone: this.timezone,
          }
        );
        this.analytics = result.analytics;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },
    watchPreview() {

      if (!this.enablePreview) {
        return;
      }
      this.previewUrl = this.film.is_external_src
        ? this.film.external_url
        : this.movie.screener_edge_url;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
      this.previewUrl = null;
    },
  }
};
</script>
